import {Table, Form, Space, Radio, Badge, Flex, InputNumber, DatePicker, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import CostCheck from './CostCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './cost.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import UserSelect from '../../system/user/UserSelect';
function CostListAll(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "ddzc_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.slice();
            if(query.ddzc_state){
              arr = arr.filter((item) => item.ddzc_state === query.ddzc_state);
            }      
            if(query.ddzc_amount){
              arr = arr.filter((item) => Number(item.ddzc_amount) === Number(query.ddzc_amount));
            }
            if(query.ddzc_kh_id){
              arr = arr.filter((item) => Number(item.ddzc_kh_id) === Number(query.ddzc_kh_id));
            }
            if(query.ddzc_date){
              arr = arr.filter((item) => dayjs(item.ddzc_date).format('YYYY-MM-DD') === query.ddzc_date);
            }
            if(query.ddzc_uid){
              arr = arr.filter((item) => item.ddzc_uid === query.ddzc_uid);
            }
            if(query.ddzc_id){
              arr = arr.filter((item) => item.key === query.ddzc_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddzc_id
            }));
            arr.sort((a, b) => new Date(b.ddzc_ctime) - new Date(a.ddzc_ctime));
            setList(arr);
        }
    }, [props.list, props.yh_id, query])
    
    const columns = [    
        {
            title: '付款客户',
            dataIndex: 'ddzc_kh_name',
            width: '12%',
            key: 'ddzc_kh_name',         
            render: (text, record) =><CostCheck
                                        type='button'
                                        ddzc_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddzc_bzd_id={record.ddzc_bzd_id}
                                        ddzc_price={record.ddzc_price}
                                        ddzc_content={record.ddzc_content}
                                        ddzc_date={record.ddzc_date}
                                        ddzc_date_end={record.ddzc_date_end}
                                        ddzc_bzd_name={record.ddzc_bzd_name}
                                        ddzc_bzd_danhao={record.ddzc_bzd_danhao}
                                        ddzc_type_id={record.ddzc_type_id}
                                        ddzc_type_name={record.ddzc_type_name}
                                        ddzc_kh_id={record.ddzc_kh_id}
                                        ddzc_kh_name={record.ddzc_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddzc_num={record.ddzc_num}
                                        ddzc_amount={record.ddzc_amount}
                                        ddzc_state={record.ddzc_state}
                                        ddzc_bm_id={record.ddzc_bm_id}
                                        ddzc_bm_name={record.ddzc_bm_name}
                                        ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                        ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                        ddzc_image_name={record.ddzc_image_name}
                                        ddzc_image_file={record.ddzc_image_file}
                                        ddzc_ctime={record.ddzc_ctime}
                                        ddzc_uid={record.ddzc_uid}
                                        yh_qx={props.yh_qx}
                                    />
        },
        {
            title: '付款金额',
            dataIndex: 'ddzc_amount',
            width: '10%',
            key: 'ddzc_amount',   
            render: (text, record) => <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'ddzc_content',
            key:'ddzc_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddzc_bzd_danhao",
            key:'ddzc_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddzc_bzd_name} dsbzd_id={record.ddzc_bzd_id} dsbzd_danhao={record.ddzc_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },  
        {
            title: '提交记录',
            dataIndex: 'ddzc_ctime',
            key:'ddzc_ctime',
            render:(text,record) => {
                return <span>{record.ddzc_uname} {record.ddzc_ctime}</span>
            }
        },    
        {
            title: '状态',
            dataIndex: 'ddzc_state',
            width: '5%',
            key: 'ddzc_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_cost_list_all'
                    form={form}
                    initialValues={{                        
                        ddzc_state: query.ddzc_state ? query.ddzc_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            ddzc_state: values.ddzc_state ? values.ddzc_state : '',
                            ddzc_kh_id: values.ddzc_kh_id ? values.ddzc_kh_id : '',
                            ddzc_name: values.ddzc_name ? values.ddzc_name : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_costList_ddzc_state', JSON.stringify(serializedValues.ddzc_state));
                        localStorage.setItem('jtg-caiwu_costList_ddzc_kh_id', JSON.stringify(serializedValues.ddzc_kh_id));
                        localStorage.setItem('jtg-caiwu_costList_ddzc_name', JSON.stringify(serializedValues.ddzc_name));
                        setQuery(prev => ({ 
                            ...prev, 
                            ddzc_state: serializedValues.ddzc_state, 
                        }));
                    }}
                >
                     <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    ddzc_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_incomeList_ddzc_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>    
                    <Form.Item name='ddzc_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, ddzc_amount: value }));
                            }}
                            value={query.ddzc_amount ? query.ddzc_amount : undefined}
                            placeholder='付款单金额'
                            name='ddzc_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, ddzc_kh_id: '' })) }}
                        placeholder='付款单客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='ddzc_kh_id'
                        onChange={(khId) => { setQuery(prev => ({ ...prev, ddzc_kh_id: khId || '' })) }}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />  
                    <Form.Item name='ddzc_date'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, ddzc_date: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.ddzc_date ? dayjs(query.ddzc_date) : null}
                            allowClear={true}
                            placeholder='付款单日期'
                            name='ddzc_date'
                        />
                    </Form.Item>          
                    <UserSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, ddzc_uid: '' })) }}
                        placeholder='操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='ddzc_uid'
                        onChange={(e) => {setQuery(prev => ({ ...prev, ddzc_uid: e.yh_id || '' }))}}
                    />
                    <Form.Item name='ddzc_id' >
                        <Input placeholder='付款单编号' onChange={(e) => {setQuery(prev => ({ ...prev, ddzc_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_costList_ddzc_state', JSON.stringify(''))
                                    setQuery({
                                        "ddzc_state": '',
                                        ddzc_kh_id: '',
                                        ddzc_amount: undefined,
                                        ddzc_uid: '',
                                        ddzc_date: '',
                                        ddzc_id: '',
                                    })
                                    form.setFieldsValue({
                                        ddzc_name: null,
                                        ddzc_kh_id: null,
                                        ddzc_bzd_danhao: null,
                                        ddzc_uid: null,
                                        ddzc_date: null,
                                        ddzc_id: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'green'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default CostListAll